import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Lock } from "lucide-react";
import { API, useAuth } from "@/contexts/AuthContext";
import { Results } from "@/pages/Notch";

export default function SharedPlan() {
  const { share_id } = useParams();
  const { user } = useAuth();
  const [plan, setPlan] = useState(null);
  const [err, setErr] = useState("");
  const [activeDay, setActiveDay] = useState(1);

  useEffect(() => {
    if (!user || user === false) return;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/plans/shared/${share_id}`);
        setPlan(data); setActiveDay(data.days?.[0]?.day || 1);
      } catch (e) {
        setErr(e?.response?.data?.detail || "Plan not found or you don't have access.");
      }
    })();
  }, [share_id, user]);

  if (user === false) {
    return (
      <main className="max-w-md mx-auto pt-20 px-4 text-center">
        <Lock size={28} className="text-[#C06F52] mx-auto mb-4" />
        <h1 className="font-serif-display text-3xl text-[#2C4C3B]">Sign in to view this plan</h1>
        <p className="text-sm text-[#666] mt-3">Shared plans are visible to logged-in Notch users only.</p>
        <Link to="/auth" state={{ from: `/share/${share_id}` }} className="inline-block mt-6 px-6 py-3 rounded-full bg-[#2C4C3B] text-white text-sm font-medium">
          Sign in / Create account
        </Link>
      </main>
    );
  }

  if (err) return <main className="max-w-md mx-auto pt-20 px-4 text-center text-sm text-[#7a3320]">{err}</main>;
  if (!plan) return <main className="max-w-md mx-auto pt-20 px-4 text-center text-sm text-[#888]">Loading shared plan…</main>;

  const fakeResults = { id: plan.id, targets: plan.targets, days: plan.days, grocery_list: plan.grocery_list, note: plan.note };
  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-8 pt-6 pb-24">
      <div className="mb-6 rounded-[1.25rem] bg-[#F2EFE9] border border-[#E5E2DC] px-5 py-3 text-xs text-[#666] inline-flex items-center gap-2">
        <Lock size={12} /> Shared plan — visible to Notch members
      </div>
      <Results results={fakeResults} activeDay={activeDay} setActiveDay={setActiveDay} />
    </main>
  );
}
